
export default {
  name: "CardViewStartupMember",
  data() {
    return {
      show: false,
      actionMenus: [
        { title: this.$t("edit"),action:1, icon:"mdi-pencil" },
        { title: this.$t("delete"),action:2, icon:"mdi-delete" },
      ],
    };
  },
  props: {
    to: { type: String, default: "" },
    name: String,
    position: String,
    status: String,
    isOwner: Boolean,
    thumbnail: { type: String, default: "/images/default-image.png" },
    isClientPage: Boolean,
    showDelete: { type: Boolean, default: false },
    memberId: Number,
    role: String,
  },
  computed: {
    ownershipLabel() {
      return this.role ? this.role : this.$t("n_a");
    },
  },
  mounted(){
  },

  methods: {
    deleteMember() {
      if (this.status) {
        // remove request
        this.$emit('delete-member', {
          isReview: true,
          memberId: this.memberId
        })
      } else {
        // remove member
        this.$emit('delete-member', {
          isReview: false,
          memberId: this.memberId
        })
      }
    },
    editMember() {
      
      this.$emit('edit-member')
    }
  },
};
